import type { ReactNode } from 'react'
import { AlertTriangle, Inbox, LoaderCircle, RefreshCw } from 'lucide-react'

export function LoadingState({ label = 'Loading workspace…' }: { label?: string }) {
  return <div className="state-panel"><LoaderCircle className="spin" /><p>{label}</p></div>
}

export function ErrorState({ title = 'Something went wrong', message, onRetry }: { title?: string; message: string; onRetry?: () => void }) {
  return (
    <div className="state-panel state-panel--error">
      <AlertTriangle />
      <div><strong>{title}</strong><p>{message}</p></div>
      {onRetry && <button className="button button--secondary" onClick={onRetry}><RefreshCw size={15} /> Retry</button>}
    </div>
  )
}

export function EmptyState({ title, description, action, icon }: { title: string; description: string; action?: ReactNode; icon?: ReactNode }) {
  return (
    <div className="empty-state">
      <div className="empty-state__icon">{icon ?? <Inbox />}</div>
      <h2>{title}</h2><p>{description}</p>{action}
    </div>
  )
}
